import { Typography } from '@mui/material';

export const Title = (props) => <Typography sx={{ pt: { xs: 2, sm: 4 }, pb: 2, fontWeight: 'bold' }} {...props} />;
export const H2 = (props) => <Title variant="h4" component="h2" {...props} />;
export const H3 = (props) => <Title variant="h5" component="h3" {...props} />;
export const H4 = (props) => <Title variant="h6" component="h4" {...props} />;

export default Title;
